import { useTitle } from 'react-use';

import { useAddInsuranceMutation } from 'services/insurance/insurance';

import { selectOrchestrate, selectSignUp } from 'store';

import PreInsurance from 'widgets/PreInsurance';

import { useAppSelector } from 'hooks';
import { handleRequestCatch } from 'utils/helpers';

import { Props } from './preInsurance.types';

const PreInsurancePage: React.FC<Props> = ({ onSelect }) => {
  useTitle('LifeMD - Insurance');
  const [addInsurance, { isLoading }] = useAddInsuranceMutation();
  const {
    user: { accessToken }
  } = useAppSelector(selectSignUp);
  const {
    user: { accessToken: orchestrateAccessToken }
  } = useAppSelector(selectOrchestrate);
  const handleSelect = async (answer: boolean) => {
    if (answer) {
      return onSelect(answer);
    }
    await addInsurance({
      accessToken: accessToken || orchestrateAccessToken,
      hasInsurance: answer
    })
      .unwrap()
      .then(() => onSelect(answer))
      .catch(handleRequestCatch);
  };

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      <h1 className="wm-signup-title md:text-center">Insurance coverage</h1>
      <PreInsurance loading={isLoading} showSubheader onSelect={handleSelect} />
    </div>
  );
};

export default PreInsurancePage;
